import { createTheme, MantineColorsTuple } from '@mantine/core';

/**
 * Every Fi color is a single flat value, but Mantine's `theme.colors` wants a 10-shade tuple, so each
 * shade is the same hex. Components that pick a shade (`color="fi-yellow"` on a Button, `c="gray-300"`
 * on Text) therefore always resolve to the design token itself.
 */
const flat = (hex: string): MantineColorsTuple => [hex, hex, hex, hex, hex, hex, hex, hex, hex, hex];

/** Shared by the app's `MantineProvider` and Storybook's decorator so stories render like the shop. */
export const theme = createTheme({
  fontFamily: 'MessinaSans, sans-serif',
  headings: { fontFamily: 'MessinaSans-Compact, sans-serif' },
  colors: {
    'fi-yellow': flat('#FFFA01'),
    'background-dark-primary': flat('#000000'),
    'background-dark-secondary': flat('#242424'),
    'background-dark-tertiary': flat('#3C3C3C'),
    'background-light-secondary': flat('#F3F3F2'),
    'background-light-tertiary': flat('#E5E5E4'),
    'type-dark-primary': flat('#FFFFFF'),
    'type-dark-secondary': flat('#9E9E9C'),
    'type-light-primary': flat('#000000'),
    'type-light-secondary': flat('#737373'),
    'stroke-dark-border': flat('#737373'),
    'gray-200': flat('#BEBEBC'),
    'gray-300': flat('#9E9E9C'),
    'gray-400': flat('#737373'),
  },
});
